import {styled, Typography} from '@mui/material';
import Box from '@mui/material/Box';

import {LeftTriangle} from 'assets/icons/leftTriangle';

export const StyledDiscountAddToBasketBtn = styled(Box)(({theme}) => ({
  display: 'flex',
  color: theme.palette.common.mds_global_color_white,
  borderRadius: '50%',
  fontSize: theme.spacing(1.75),
  '&.updatedQuantityBgColor': {
    background: theme.palette.primary.dark,
    boxShadow: `0 0 0 ${theme.spacing(0.25)} ${theme.palette.common.mds_global_color_white}, 0 0 0 ${theme.spacing(
      0.125
    )} ${theme.palette.primary.dark}`
  },
  '&.normalQuantityBgColor': {
    backgroundColor: theme.palette.common.mds_global_color_white
  },
  width: theme.spacing(4),
  height: theme.spacing(4),
  [theme.breakpoints.down('sm')]: {
    width: theme.spacing(3.5),
    height: theme.spacing(3.5)
  },
  '&.compact': {
    width: theme.spacing(3.5),
    height: theme.spacing(3.5)
  }
}));

export const StyledDiscountPercentageContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  paddingRight: theme.spacing(0),
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: theme.spacing(0, 0.375, 0.375, 0),
  background: theme.palette.primary.main
}));

export const StyledDiscountPercentageTypography = styled(Typography)(({theme}) => ({
  color: theme.palette.common.mds_global_color_white,
  textAlign: 'center',
  fontStyle: 'normal',
  fontWeight: 600,
  paddingRight: theme.spacing(0.25),
  lineHeight: theme.spacing(1.75),
  fontSize: theme.spacing(1.5),
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.spacing(1.25)
  }
}));

export const StyledDiscountPrice = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  borderRadius: theme.spacing(0, 0.75, 0, 0.75),
  background: theme.palette.secondary.main,
  width: 'fit-content',
  position: 'absolute',
  left: theme.spacing(0),
  bottom: theme.spacing(0),
  '&.slabPriceDiscountSectionPadding': {
    padding: theme.spacing(0.4375, 0.5, 0.4875, 1),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(0.4375, 0.5, 0.5125, 1)
    }
  },
  '&.discountSectionPadding': {
    padding: theme.spacing(0.4375, 0.5, 0.4125, 1),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(0.4375, 0.5, 0.5125, 1)
    }
  }
}));

export const StyledDiscountPriceTypography = styled(Typography)(({theme}) => ({
  color: theme.palette.common.mds_global_color_white,
  fontWeight: 400,
  textDecorationLine: 'line-through',
  display: 'flex',
  fontSize: theme.spacing(1.5),
  lineHeight: theme.spacing(1.8),
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.spacing(1.25),
    lineHeight: theme.spacing(1.5)
  }
}));

export const StyledDiscountStrikedPriceSymbolTypography = styled(Box)(({theme}) => ({
  color: theme.palette.common.mds_global_color_white,
  fontStyle: 'normal',
  fontWeight: 600,
  display: 'inline',
  fontSize: theme.spacing(1.5),
  lineHeight: theme.spacing(2.27),
  marginLeft: theme.spacing(0.25),
  alignItems: 'end',
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.spacing(1.25),
    lineHeight: theme.spacing(1.89)
  },
  '&.noDiscount': {
    color: theme.palette.secondary.main
  }
}));

export const StyledDiscountStrikedPriceSymbol = styled(Box)(({theme}) => ({
  color: theme.palette.common.mds_global_color_white,
  fontStyle: 'normal',
  fontWeight: 400,
  display: 'flex',
  textDecorationLine: 'line-through',
  marginLeft: theme.spacing(-0.75),
  fontSize: theme.spacing(1.5),
  marginRight: theme.spacing(-0.5),
  marginTop: theme.spacing(0.125),
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.spacing(1.25)
  }
}));

export const StyledUpdatedQuanityTypography = styled(Typography)(({theme}) => ({
  fontSize: theme.spacing(2),
  fontWeight: 600,
  textAlign: 'center',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '&.medium': {
    fontSize: theme.spacing(1.75)
  },
  '&.small': {
    fontSize: theme.spacing(1.25)
  },
  '&.extraSmall': {
    fontSize: theme.spacing(1)
  },
  [theme.breakpoints.down('sm')]: {
    '&.medium': {
      fontSize: theme.spacing(1.5)
    },
    '&.small': {
      fontSize: theme.spacing(1)
    },
    '&.extraSmall': {
      fontSize: theme.spacing(0.75)
    }
  }
}));

export const StyledDiscountOrSlabPriceContent = styled(Box)(() => ({
  '&.left': {
    flexGrow: 1,
    overflow: 'hidden'
  },
  '&.right': {
    flexShrink: 0,
    display: 'flex',
    justifyContent: 'end',
    alignItems: 'center'
  }
}));

export const StyledSlabPriceText = styled(Box)(({theme}) => ({
  overflow: 'visible',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 1,
  color: theme.palette.common.mds_global_color_white,
  fontWeight: 600,
  fontSize: theme.spacing(1.5),
  lineHeight: theme.spacing(1.8),
  width: 'max-content',
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.spacing(1.25),
    lineHeight: theme.spacing(1.5)
  },
  '&.textColorForAddToCart': {
    color: theme.palette.secondary.main,
    paddingTop: theme.spacing(1)
  }
}));

export const StyledDiscountOrSlabPriceContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  borderRadius: theme.spacing(1),
  background: theme.palette.primary.main,
  padding: theme.spacing(0.5, 1, 0.5, 1),
  minWidth: theme.spacing(15),
  position: 'relative',
  '&.slabPrices': {
    height: theme.spacing(8.375)
  },
  '&.discount': {
    height: theme.spacing(6.5)
  },
  [theme.breakpoints.down('sm')]: {
    '&.slabPrices': {
      height: theme.spacing(7.5)
    },
    '&.discount': {
      height: theme.spacing(6)
    }
  },
  '&.noBgColorForAddToCart': {
    background: theme.palette.common.mds_global_color_white,
    padding: 0,
    flexDirection: 'column',
    justifyContent: 'center'
  }
}));

export const StyledLeftTriangleIcon = styled(LeftTriangle)(({theme}) => ({
  width: theme.spacing(1.75),
  height: theme.spacing(0.75),
  transform: 'rotate(-90deg)',
  left: theme.spacing(-0.75),
  top: theme.spacing(0),
  fill: theme.palette.primary.main
}));

export const DiscountWeightedFreshKgText = styled('span')(({theme}) => ({
  color: theme.palette.common.mds_global_color_white,
  fontWeight: theme.typography.fontWeightBold,
  fontSize: theme.spacing(2),
  paddingLeft: theme.spacing(0.25),
  '&.plp': {
    fontSize: theme.spacing(1.75)
  },
  '&.noDiscount': {
    color: theme.palette.grey[400]
  },
  [theme.breakpoints.down('sm')]: {
    '&.addToCart, &.plp': {
      fontSize: theme.spacing(1.5)
    }
  }
}));

export const NoDiscountNormalPriceWrapper = styled(Box)(({theme}) => ({
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  paddingRight: theme.spacing(0.25)
}));

export const StyledNormalPriceText = styled(Box)(({theme}) => ({
  color: theme.palette.common.mds_global_color_white,
  fontWeight: 700,
  display: 'flex',
  fontSize: theme.spacing(3),
  lineHeight: theme.spacing(3),
  '&.textColorForAddToCart': {
    color: theme.palette.secondary.main,
    paddingTop: theme.spacing(1)
  },
  '&.addToCart': {
    fontSize: theme.spacing(2.5),
    lineHeight: theme.spacing(2.7),
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.spacing(2.25),
      lineHeight: theme.spacing(2.5)
    }
  },
  '&.plp': {
    fontSize: theme.spacing(2.5),
    lineHeight: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.spacing(2.25),
      lineHeight: theme.spacing(2.7)
    }
  }
}));
